module.exports = __webpack_public_path__ + "img/notification-grey.55f0e2c2.svg";